import React from 'react';
import pt from 'prop-types';
import { timeGreeting } from 'utils';
import Action from 'partners/components/action';
import { HOME_ACTIONS } from './configs';
import './home.scss';

export default class HomePage extends React.PureComponent {
  static contextTypes = {
    user: pt.object.isRequired,
  };

  renderActions = () => {
    return HOME_ACTIONS.map((action, i) => <Action key={i} {...action} />);
  };

  render() {
    const { user } = this.context;

    return (
      <div className="home">
        <div className="home-welcome">
          <h2 className="home-welcome-title">
            Good {timeGreeting()}, {user.firstName}
          </h2>
          {this.renderActions()}
        </div>
      </div>
    );
  }
}
